import { useTranslation } from "react-i18next";
import { Container, Terms, Wrapper } from "./index.styled";
import { useCallback, useEffect, useState } from "react";
import Backdrop from "../backdrop/backdrop";
import { Button, Text } from "../common";
import { useTheme } from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../store/app-state";
import { updateTermAccept } from "../../store/auth/auth-actions";

export const TermsOfAccept: React.FC = () => {
  const { t } = useTranslation("private-home-page");
  const root = (key: string) => t(`callToAcceptTerms.${key}`);
  const [acceptTerms, setAcceptTerms] = useState<boolean>(false);
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const user = useSelector((state: AppState) => state.authState.user);
  const dispatch = useDispatch();

  const handleAccept = useCallback(() => {
    setOpen(false);
    dispatch(updateTermAccept());
  }, [setOpen, dispatch]);

  useEffect(() => {
    if (user) {
      setOpen(user.setup && user.corporate && !user.terms_of_accept_talent 
        && !window.location.pathname.includes("onboarding"));
    }
  }, [user, dispatch]);

  return open ? (
    <>
      <Backdrop isShown={true} toggle={() => {}} />
      <Container>
        <Text as="h3" color={theme?.colors?.primaryBlue?.main} margin="0">
          {root("title")}
        </Text>
        <Wrapper>
          <input
            type="checkbox"
            id="terms"
            name="terms"
            value="terms"
            checked={acceptTerms}
            onChange={() => setAcceptTerms(!acceptTerms)}
          />
          <Terms as="p" color={"black"}>
            {root("byClicking")} <a href="/policies">{root("terms")}</a>{" "}
            {root("and")} <a href="/terms">{root("privacy")}</a>{" "}
            {root("talent")}
          </Terms>
        </Wrapper>
        <Button
          disabled={!acceptTerms}
          backgroundColor={theme?.colors?.primaryBlue?.main ?? "#fff"}
          textColor={theme?.colors?.primaryBlue?.text ?? "#000"}
          width="100%"
          onClick={handleAccept}
        >
          {root("accept")}
        </Button>
      </Container>
    </>
  ) : null;
};
